import { lazyLoad } from 'utils/loadable';

export const GenerateRecoveryCodes = lazyLoad(
  () => import('./generateRecoveryCodes.page'),
  (module) => module.GenerateRecoveryCodes
);
